export function distanceSquareRoot(a: [number, number], b: [number, number]) {
  return Math.sqrt((a[0] - b[0]) * (a[0] - b[0]) + (a[1] - b[1]) * (a[1] - b[1]));
}
